import React, { useImperativeHandle, forwardRef, useEffect, useRef } from 'react';
import { Form, Input, Button, Row, Col, Space, Select } from 'antd';
import { drugNameTypes } from '../constants';
import { useTranslation } from 'react-i18next';

interface IProps {
  onQuery?: (value: any) => void;
  loading?: boolean;
  initialValue: any
}

const QueryForm = ({ onQuery, initialValue, loading }: IProps, ref: any) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const initialInfo = useRef<IProps['initialValue']>();

  const onFinish = (values: any) => {
    if (typeof onQuery === 'function') {
      onQuery(values);
    }
  };

  const onReset = () => {
    form.resetFields();
    if (initialInfo.current) {
      form.setFieldsValue(initialInfo.current);
      initialInfo.current = undefined;
      
    }
    if (typeof onQuery === 'function') {
      onQuery({...form.getFieldsValue()});
    }
  };

  useImperativeHandle(ref, () => ({
    resetQuery: onReset,
    submitQuery: () => form.submit(),
  }));
  
  useEffect(()=>{
    initialInfo.current = { drugName: initialValue.name };
  },[initialValue?.name])

  return (
    <Form
      form={form}
      layout="inline"
      onFinish={onFinish}
      labelCol={{ span: 6 }}
      labelAlign="left"
      autoComplete="off"
    >
      <Row gutter={[16, 16]}>
        <Col span={8}>
          <Form.Item label={t('dict.drugName')} name="drugName">
            <Input placeholder={t('ikg.input',{name:t('dict.drugName')})} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label={t('dict.drugNameType')} name="tradeOrIngredient">
            <Select
              placeholder={t('ikg.select',{name:t('dict.drugNameType')})}
              options={drugNameTypes}
              allowClear
            />
          </Form.Item>
        </Col>
       
        <Col span={8}>
          <Form.Item label={t('dict.drugRecordNo')} name="drugRecordNumber">
            <Input placeholder={t('ikg.input',{name:t('dict.drugRecordNo')})} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="MPID" name="medicinalProdId">
            <Input placeholder={t('ikg.input',{name:'MPID'})} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label={t('dict.country')} name="countryName">
            <Input placeholder={t('ikg.input',{name:t('dict.country')})} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label={t('dict.dosageForm')} name="drugType">
            <Input placeholder={t('ikg.input',{name:t('dict.dosageForm')})} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="MAH" name="mah">
            <Input placeholder={t('ikg.input',{name:'MAH'})} />
          </Form.Item>
        </Col>
        <Space>
          <Button onClick={onReset}>{t('ikg.reset')}</Button>
          <Button type="primary" htmlType="submit" ghost loading={loading}>
            {t('ikg.query')}
          </Button>
        </Space>
      </Row>
    </Form>
  );
};

export default forwardRef(QueryForm);
